import React from 'react';

import { trackingId } from '@blueprint/ui';

import Notification from './Notification';

/**
 * ContextualNotification
 */
const SystemNotification = React.forwardRef(({ variant, ...rest }, ref) => (
  <Notification
    ref={ref}
    variant={`system.${variant}`}
    data-testid="SystemNotification"
    data-trackid={trackingId('SystemNotification')}
    {...rest}
  />
));

SystemNotification.displayName = 'SystemNotification';

export default SystemNotification;
